$( document ).ready( function () {
  // Scroll to the booking details block
  $( document ).on( 'click', '.book-now', ( event ) => {
    $( '.quotation-booking-details' ).show();
    $( 'html, body' ).animate( { scrollTop: $( '.quotation-booking-details' ).offset().top }, 'slow' );
    const $selectedPrice = $( '.quote-result.selected .quote-price .selected' );
    $( '.secure-payment .price span' ).html( $selectedPrice.attr( 'data-price' ) );
    const path = $( event.currentTarget ).attr( 'data-path' );
    $.post( '/apincm.php/quote-final', {
      id: getUrlParameter( 'id' ),
      GUID: getUrlParameter( 'GUID' ),
      pathNum: path,
      option: $selectedPrice.attr( 'data-option' )
    } );

    return false;
  } );

  // Scroll to the top results
  $( document ).on( 'click', '.quotation-booking-details .change-option', () => {
    $( 'html, body' ).animate( { scrollTop: $( '.quotation .title' ).offset().top }, 'slow' );
    return false;
  } );

  // Copy data to the origin details fields
  $( document ).on( 'click', '.copy-origin', () => {
    let hasError = false;

    const fields = $( '.quotation-booking-details .booking-info input' ).map( ( index, input ) => ({
      name: $( input ).attr( 'name' ),
      value: $( input ).val().trim()
    }) ).get();

    const { isEmptyRequiredField, isValidEmail } = createValidation( '.quotation-booking-details .booking-info' );

    fields.forEach( field => {
      if (field.name === 'email') {
        if (!isValidEmail( field )) {
          hasError = true;
        }
      }
      if (isEmptyRequiredField( field )) {
        hasError = true;
      }
    } );

    const fieldsObject = fields.reduce( ( result, field ) => ({
      ...result,
      [field.name]: field.value
    }), {} );

    if (!hasError) {
      $( '.origin-details input[name=originName]' ).val( `${fieldsObject['firstName']} ${fieldsObject['lastName']}` );
      $( '.origin-details input[name=originEmail]' ).val( fieldsObject['email'] );
      $( '.origin-details input[name=originPhone]' ).val( fieldsObject['phone'] );
    }
  } );

  // Copy data to the destination details fields
  $( document ).on( 'click', '.copy-destination', () => {
    let hasError = false;

    const fields = $( '.quotation-booking-details .booking-info input' ).map( ( index, input ) => ({
      name: $( input ).attr( 'name' ),
      value: $( input ).val().trim()
    }) ).get();

    const { isEmptyRequiredField, isValidEmail } = createValidation( '.quotation-booking-details .booking-info' );

    fields.forEach( field => {
      if (field.name === 'email') {
        if (!isValidEmail( field )) {
          hasError = true;
        }
      }
      if (isEmptyRequiredField( field )) {
        hasError = true;
      }
    } );

    const fieldsObject = fields.reduce( ( result, field ) => ({
      ...result,
      [field.name]: field.value
    }), {} );

    if (!hasError) {
      $( '.destination-details input[name=deliveryName]' ).val( `${fieldsObject['firstName']} ${fieldsObject['lastName']}` );
      $( '.destination-details input[name=deliveryEmail]' ).val( fieldsObject['email'] );
      $( '.destination-details input[name=deliveryPhone]' ).val( fieldsObject['phone'] );
    }
  } );

  // Submit booking details
  $( document ).on( 'submit', '.quotation-booking-details form', () => {
    $( '.quotation-booking-details .form-button .button' ).attr( 'disabled', true ).addClass( 'disabled' );
    $( '.quotation-booking-details .error-message' ).hide();
    let hasError = false;

    const fields = $( '.quotation-booking-details input' ).map( ( index, input ) => ({
      name: $( input ).attr( 'name' ),
      value: $( input ).val().trim()
    }) ).get();

    const { isEmptyRequiredField, isValidEmail } = createValidation( '.quotation-booking-details' );

    fields.forEach( field => {
      if (field.name.toLowerCase().indexOf( 'email' ) + 1) {
        if (!isValidEmail( field )) {
          hasError = true;
        }
      }
      if (isEmptyRequiredField( field )) {
        hasError = true;
      }
    } );

    const fieldsObject = fields.reduce( ( result, field ) => ({
      ...result,
      [field.name]: field.value
    }), {} );

    if (hasError) {
      event.preventDefault();
      $( '.quotation-booking-details .form-button .button' ).attr( 'disabled', false ).removeClass( 'disabled' );
      return false;
    }

    const quoteCar = {
      id: getUrlParameter( 'id' ),
      GUID: getUrlParameter( 'GUID' )
    };

    Promise.all( [
      $.post( '/apincm.php/book1', { ...mapBook1ToRequest( fieldsObject ), ...quoteCar } ),
      $.post( '/apincm.php/book2', { ...mapBook2ToRequest( fieldsObject ), ...quoteCar } ),
      $.post( '/apincm.php/book3', { ...mapOriginDetailsToRequest( fieldsObject ), ...quoteCar } ),
      $.post( '/apincm.php/book4', { ...mapDeliveryDetailsToRequest( fieldsObject ), ...quoteCar } )
    ] ).then( () => {
      $( '.secure-payment .fields input[name=invoiceName]' ).val( `${fieldsObject['firstName']} ${fieldsObject['lastName']}` );
      $( '.secure-payment .fields input[name=invoiceEmail]' ).val( fieldsObject['email'] );
      $( '.secure-payment' ).show();
    } )
      .catch( xhr => {
        const errors = JSON.parse( xhr.responseText );
        showFormErrors( errors, '.quotation-booking-details' );
      } )
      .finally( () => $( '.quotation-booking-details .form-button .button' ).attr( 'disabled', false ).removeClass( 'disabled' ) );


    return false;
  } );

  // Submit secure payment
  $( document ).on( 'submit', '.secure-payment form', ( event ) => {
    let hasError = false;
    $( '.secure-payment .error-message' ).hide();
    $( '.secure-payment .form-button .button' ).attr( 'disabled', true ).addClass( 'disabled' );

    const fields = $( '.secure-payment .fields input' ).map( ( index, input ) => ({
      name: $( input ).attr( 'name' ),
      value: $( input ).val().trim()
    }) ).get();

    const { isEmptyRequiredField, isValidEmail } = createValidation( '.secure-payment .fields' );

    fields.forEach( field => {
      if (field.name === 'invoiceEmail') {
        if (!isValidEmail( field )) {
          hasError = true;
        }
      }
      if (isEmptyRequiredField( field )) {
        hasError = true;
      }
    } );

    const fieldsObject = fields.reduce( ( result, field ) => ({
      ...result,
      [field.name]: field.value
    }), {} );

    fieldsObject.paymentWay = $( '.secure-payment .payment-way input[name=paymentWay]:checked' ).val();

    if (hasError) {
      event.preventDefault();
      $( '.secure-payment .form-button .button' ).attr( 'disabled', false ).removeClass( 'disabled' );
      return false;
    }

    $.post( '/apincm.php/payment-update', {
      ...mapSecurePaymentToRequest,
      id: getUrlParameter( 'id' ),
      GUID: getUrlParameter( 'GUID' )
    } )
      .done( response => {
        if (fieldsObject['paymentWay'] === '4') {
          window.location = `/quote-results-page/booking-summary-bank/?id=${getUrlParameter( 'id' )}`;
        }
      } )
      .fail( jqXHR => {
        const errors = JSON.parse( jqXHR.responseText );
        showFormErrors( errors, '.secure-payment .fields' );
      } )
      .always( () => $( '.secure-payment .form-button .button' ).attr( 'disabled', false ).removeClass( 'disabled' ) );

    return false;
  } );

  // Display tooltip with uber data
  $( document ).on( 'click', '.quote-result .uber', ( event ) => {
    const element = $( event.currentTarget );
    const depotId = element.attr( 'data-depot-id' );
    const suburbId = element.attr( 'data-suburb-id' );

    element.addClass( 'loading' );

    $.get( `/apincm.php/uber?depotID=${depotId}&suburbID=${suburbId}` )
      .done( response => {
        element.removeClass( 'loading' );
        const uberData = JSON.parse( response );
        element.popup( {
          popup: element.next()
        } );

        const mappedUber = uberData.map( uber =>
          `<div class="item">
            <div>${uber.dispatcher_name}</div>
            <div>${uber.estimate}</div>
          </div>`
        );

        element.next().html( `<div class="tooltip-content">${mappedUber.join( '' )}</div>` );

        element.popup( 'show' );
      } );
  } );

  // Price change according to checkboxes
  $( document ).on( 'change', '.quote-result .checkboxes input', ( event ) => {
    const $input = $( event.currentTarget );
    const $priceContainer = $input.parents( '.quote-result' ).find( '.quote-price' );
    const selectedPrice = $priceContainer.find( '.selected' ).attr( 'data-price' );
    let option = 0;
    // Price addition if checked
    if ($input.is( ':checked' )) {
      const currentPrice = $input.attr( 'data-price' );
      $priceContainer.find( 'div' ).each( ( index, element ) => {
        if (+$( element ).attr( 'data-price' ) === +selectedPrice + +currentPrice) {
          $priceContainer.find( 'div' ).removeClass( 'selected' );
          $( element ).addClass( 'selected' );
          option = $( element ).attr( 'data-option' );
          return false;
        }
      } );
    } else {
      // Subtract price if not checked
      const currentPrice = $input.attr( 'data-price' );
      $priceContainer.find( 'div' ).each( ( index, element ) => {
        if (+$( element ).attr( 'data-price' ) === +selectedPrice - +currentPrice) {
          $priceContainer.find( 'div' ).removeClass( 'selected' );
          $( element ).addClass( 'selected' );
          option = $( element ).attr( 'data-option' );
          return false;
        }
      } );
    }
  } );

  // Sorting results
  $( document ).on( 'click', '.sort-dropdown .menu .item', ( event ) => {
    const sort = $( event.currentTarget ).attr( 'data-value' );
    if (sort === 'cheapest' || sort === 'fastest') {
      const result = $( '.tab.active .quote-result' ).sort( ( a, b ) =>
        $( b ).find( `.additional-label.${sort}` ).length - $( a ).find( `.additional-label.${sort}` ).length
      );
      $( '.tab.active .quote-result-container' ).html( result );
    } else if (sort === 'closestFrom') {
      const result = $( '.tab.active .quote-result' ).sort( ( a, b ) =>
        Number( $( a ).find( '.route-from .distance' ).attr( 'data-distance' ) ) - Number( $( b ).find( '.route-from .distance' ).attr( 'data-distance' ) )
      );
      $( '.tab.active .quote-result-container' ).html( result );
    } else {
      // Sorting by closestTo
      const result = $( '.tab.active .quote-result' ).sort( ( a, b ) =>
        Number( $( a ).find( '.route-to .distance' ).attr( 'data-distance' ) ) - Number( $( b ).find( '.route-to .distance' ).attr( 'data-distance' ) )
      );
      $( '.tab.active .quote-result-container' ).html( result );
    }
  } )
} );

